export default "__VITE_ASSET__3e9c24ec__"